import React from "react";
import { useLocation } from "react-router-dom";
import SesHeader from "../header";

const Interstitial = ({ phrases, interstitialContinue }) => {
    const location = useLocation();
    return (
        <div className="container bg01 roundness_1">
            <div className="g-container_12 p4 py3_tablet px4_mobile flex_col align-items_start g5 g3_mobile">
                <div className="g-item_12 flex_col align-items_center justify-content_center align-self-stretch g1 pb1">
                    <SesHeader
                        clientCobranding={location.state.cobrandingLink}
                        isWarmUp={false}
                    />
                </div>
                <div className="g-item_12 flex_col align-items_start align-self-stretch g2">
                    <div className="flex g2 align-items_center">
                        <span className="material-icons">
                            sentiment_satisfied_alt
                        </span>
                        <h3>{phrases?.["20023550"]}</h3>
                    </div>
                    <div className="flex_col align-items_start align-self-stretch text-02 full-width">
                        <span>{phrases?.["20023551"]}</span>
                        <span>{phrases?.["20023557"]}</span>
                        <span>{phrases?.["20023558"]}</span>
                    </div>
                </div>
                <div className="g-item_12 flex_col align-items_end justify-content_center align-self-stretch g4">
                    <div className="flex align-self-stretch align-items_center justify-content_center full-width">
                        <div className="full-width"></div>
                    </div>
                    <div className="flex g4 align-items_center justify-content_end">
                        <button
                            className="button-primary text_uppercase"
                            onClick={interstitialContinue}
                        >
                            {phrases?.["10928"]}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Interstitial;
